<script>
    import Select from "svelte-select/Select.svelte";

    import {
        loggedInDoctorDetail,
        accountDoctors,
    } from "../../../stores";

    import {
        NotificationModal,
        SearchSelect,
    } from "../../../Components/Common/index.svelte";

    import { apiMethods } from "../../../Services/index.svelte";

    import {
        getOptionLabelForSurgeon,
        getSearchSurgeonOptions,
    } from "../../../Utils/utilFunctions.svelte";

    import { AustralianStates } from "../../../Utils/utilEnums.svelte";

    import { SEARCH } from "../../../Utils/utilConstants.svelte";

    export let isCreateNewSurgeonModalOpen = false;
    export let reloadSurgeonDetails = () => {};
    export let closeFunc = () => {};
    export let filters = {};
    export let existedOptions = [];

    export let doctorId, selectedSurgeon;

    $: if (!isCreateNewSurgeonModalOpen) {
        filters.name = "";
    }

    let proceduralSpecialityCodes = [
        4,
        5,
        7,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        42,
        46,
        52,
        53,
        54,
        55,
        56,
        62,
        73,
        84,
        85,
        87,
        99,
        110,
        153,
        157,
        158,
        606,
        611,
        808
    ];

    let isLoadingProviders = false,
        filterByProceduralSpecialityCdes = true,
        isCreatingNewSurgeon = false,
        filteredProviders = [],
        selectedProviderDetails;

    const handleFilterSelect = () => {
        if (filters && filters.name) loadAllProviders();
    };

    const handleDoctorSearch = async (text) => {
        if (!text || text.length < 2) {
            return [];
        }
        filters.name = text;

        if (filterByProceduralSpecialityCdes)
            filters.specialityCode = proceduralSpecialityCodes.join(",");
        else delete filters.specialityCode;

        await loadAllProviders();
    };

    const loadAllProviders = async () => {
        isLoadingProviders = true;

        filteredProviders = [];

        selectedProviderDetails = null;

        await apiMethods.getMethod
            .getAllProviders(0, 999999, filters)
            .then((res) => {
                if (!res.error)
                    filteredProviders = _filterProviders(res.results);
                else filteredProviders = [];
            });

        isLoadingProviders = false;
    };

    const clearCurrentProvider = () => {
        selectedProviderDetails = null;
    };

    const createSurgeon = async () => {
        if (
            (!doctorId && !$loggedInDoctorDetail.id) ||
            !selectedProviderDetails?.uniqueId
        )
            return;

        isCreatingNewSurgeon = true;

        const obj = {
            doctorId: doctorId ?? $loggedInDoctorDetail.id,
            providerUniqueId: selectedProviderDetails.uniqueId,
        };

        await apiMethods.postMethod
            .createSurgeon(obj)
            .then((res) => {
                if (res.id) {
                    reloadSurgeonDetails();
                    if (doctorId)
                        selectedSurgeon = {
                            ...selectedProviderDetails,
                            id: res.id,
                            displayLabel: getOptionLabelForSurgeon(
                                selectedProviderDetails,
                            ),
                        };
                }
            })
            .then(() => closeCreateSurgeonModal());

        isCreatingNewSurgeon = false;
    };

    const closeCreateSurgeonModal = () => {
        filters = { state: "VIC" };

        clearCurrentProvider();

        closeFunc();
    };

    // HELPER FUNCTIONS
    const _filterProviders = (arr = []) => {
        if (!arr.length) return [];

        const targetArr = existedOptions.length
            ? existedOptions
            : $accountDoctors;

        if (!targetArr.length) return getSearchSurgeonOptions(arr);

        const providerIds = targetArr.map(
            ({ providerUniqueId }) => providerUniqueId,
        );

        return getSearchSurgeonOptions(
            arr.filter(({ uniqueId }) => !providerIds.includes(uniqueId)), true, true
        );
    };
</script>

<NotificationModal
    isModalOpen={isCreateNewSurgeonModalOpen}
    title="Add new surgeon/referrer"
    cancelText="Cancel"
    modalMaxWidth="max-w-4xl"
    submitText={isCreatingNewSurgeon ? "Adding" : "Add"}
    closeModal={closeCreateSurgeonModal}
    confirmAction={createSurgeon}
    contentClass="flex flex-col p-6"
    isConfirming={isCreatingNewSurgeon}
    closeModalFunction={closeCreateSurgeonModal}
>
    <div class="flex flex-1 flex-col gap-y-4">
        <div class="flex flex-1 justify-between gap-2">
            <SearchSelect
                bind:value={filters.state}
                title="State"
                wrapperClass="flex-1"
                inputClass={`bg-[#ffffff] force-w-full ${
                    isLoadingProviders ? "cursor-not-allowed" : ""
                }`}
                onChangeFunc={handleFilterSelect}
                isLong
                isDisable={isLoadingProviders}
            >
                {#each AustralianStates as state}
                    <option
                        value={state.key.toUpperCase()}
                        selected={state.key == "vic"}
                    >
                        {state.name} - {state.key.toUpperCase()}
                    </option>
                {/each}
            </SearchSelect>
        </div>

        <div class="flex items-center gap-x-2 pt-4">
                <input
                    type="checkbox"
                    class="toggle toggle-secondary"
                    bind:checked={filterByProceduralSpecialityCdes}
                />
                Filter for procedural speciality       
            </div>

        <div class="flex w-full">
            <Select
                bind:value={selectedProviderDetails}
                loadOptions={handleDoctorSearch}
                items={filteredProviders}
                itemId="uniqueId"
                label="displayName"
                debounceWait={SEARCH.DEBOUNCE_TIME}
                on:clear={clearCurrentProvider}
                noOptionsMessage="No Provider found"
                placeholder={isLoadingProviders ? "Loading..." : "Select"}
                loading={isLoadingProviders}
            />
        </div>
    </div>
</NotificationModal>
